import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppStateLogin } from "../../redux/auth";
import { IAppState } from "../../redux/types";
import { Dispatcher } from "../../service/RootDispather";
import { StorageHelper } from "../../utils/StorageHelper";
import { Preloader } from "../preloader/Preloaders";
import SignIn from "./SignIn";
const StartViewNew = (): JSX.Element => {
  const rootDispatcher = Dispatcher();
  const { isLoading, error, isAuthorized, isAuthenticated } = useSelector<
    IAppState,
    AppStateLogin
  >((state) => state.auth);

  const hasRefreshToken =
    StorageHelper.instance.GetRefreshToken() !== undefined;
  const [tokenRotated, settokenRotated] = useState(false);
  const [shouldDisplaySignUp, setshouldDisplaySignUp] = useState(false);
  useEffect(() => {
    console.log(hasRefreshToken, isAuthorized);
    if (hasRefreshToken && isAuthorized) {
      rootDispatcher.getAuthData();
      settokenRotated(true);
    } else if (!hasRefreshToken) setshouldDisplaySignUp(true);
  }, [hasRefreshToken, isAuthorized, rootDispatcher]);

  useEffect(() => {
    if (tokenRotated && !isAuthenticated && isLoading === false)
      setshouldDisplaySignUp(true);
  }, [tokenRotated, isAuthenticated, isLoading]);

  const [errorFinishedShowing, setFinishedShowing] = useState(false);
  useEffect(() => {
    if (error !== undefined) {
      setTimeout(() => {
        setFinishedShowing(true);
      }, 5000);
    }
  }, [error]);
  if (error !== undefined && errorFinishedShowing) return;
  console.log(shouldDisplaySignUp);
  if (shouldDisplaySignUp) return <SignIn />;
  return <Preloader />;
};

export default React.memo(StartViewNew);
